import React from "react";
import { MapPin } from "lucide-react";

const PARISHES = [
  { name: "Kingston & St. Andrew", phase: "Phase 1" },
  { name: "St. Catherine", phase: "Phase 1" },
  { name: "St. James", phase: "Phase 1" },
  { name: "St. Ann", phase: "Phase 2" },
  { name: "St. Elizabeth", phase: "Phase 2" },
  { name: "Manchester", phase: "Phase 3" },
  { name: "Portland", phase: "Phase 3" },
];

export default function GeographicCoverage() {
  return (
    <section
      id="where-we-serve"
      data-testid="geographic-coverage"
      className="py-24 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-full bg-[var(--gg-primary)]/10 flex items-center justify-center text-[var(--gg-primary)]">
                <MapPin size={18} strokeWidth={1.6} />
              </span>
              <span className="eyebrow">Where we serve</span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[54px] text-[var(--gg-deep)] mt-4 leading-[1.05] font-semibold text-balance">
              Expanding thoughtfully
              <br />
              <em className="not-italic text-[var(--gg-primary)] font-normal">
                across Jamaica.
              </em>
            </h2>
            <p className="mt-6 text-[var(--gg-text)] leading-relaxed max-w-md">
              Beginning in the urban centres and moving into premium
              retirement-friendly and coastal parishes, on a schedule that lets
              us grow without compromising quality.
            </p>
          </div>
          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {PARISHES.map((p) => (
                <div
                  key={p.name}
                  data-testid={`parish-${p.name}`}
                  className="rounded-xl bg-[var(--gg-surface)] border border-[var(--gg-border)] px-4 py-5 hover:bg-[var(--gg-cream)] hover:border-[var(--gg-secondary)] transition-colors"
                >
                  <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--gg-primary)] mb-1.5 font-semibold">
                    {p.phase}
                  </div>
                  <div className="text-sm text-[var(--gg-deep)] font-medium">
                    {p.name}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
